export const SET_PSI_TOKEN = "SET_PSI_TOKEN"
export const LOGOUT_USER = "LOGOUT_USER"
export const CHECK_LOCAL_STORAGE = "CHECK_LOCAL_STORAGE"
export const SET_USER = "SET_USER"
export const SET_USER_CONFIG = "SET_USER_CONFIG"
export const SET_PRODUCTS = "SET_PRODUCTS"
export const SET_RISK_TYPE = "SET_RISK_TYPE"
export const SET_RISK_PROFILER_INFO = "SET_RISK_PROFILER_INFO"
export const SET_DEFAULT_RISK_PROFILER = "SET_DEFAULT_RISK_PROFILER"
export const SET_PAYU_HASH = "SET_PAYU_HASH"
export const SET_PAYMENT_REQUEST = "SET_PAYMENT_REQUEST"
export const SET_PAYMENT_PROCESS = "SET_PAYMENT_PROCESS"
export const SET_USER_SUBSCRIPTION = "SET_USER_SUBSCRIPTION"
export const SET_USER_TRANSACTIONS = "SET_USER_TRANSACTIONS"
export const SET_USER_REPORTS = "SET_USER_REPORTS"
export const SET_GET_BROKER_ALL_LEADS = "SET_GET_BROKER_ALL_LEADS"
export const SET_CKYC_STATUS = "SET_CKYC_STATUS"


// WEBPACK FOOTER //
// ./src/store/mutations.type.js